import React, { useState, useMemo } from "react";
import axios from "axios";
import { REPORTS_API_ROOT } from "./config/api";

function Loader() {
  return (
    <div style={{ display: "flex", justifyContent: "center", padding: "20px" }}>
      <div className="spinner-wrapper">
        <div className="spinner">
          <div></div><div></div><div></div><div></div>
        </div>
      </div>
    </div>
  );
}

const AttendanceReport = () => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [data, setData] = useState([]);
  const [editRow, setEditRow] = useState(null);
  const [editData, setEditData] = useState({});
  const [loading, setLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);

  const API = REPORTS_API_ROOT;

  const fetchData = async () => {
    if (!fromDate || !toDate) {
      alert("Please select both dates");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.get(`${API}/attendance/list`, { params: { fromDate, toDate } });
      setData(res.data.data || []);
      setHasSearched(true);
    } catch (err) {
      alert("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  const startEdit = (row, rowKey) => {
  setEditRow(rowKey);       // set unique rowKey
  setEditData({ ...row });  // copy entire row into editData
};



const saveRow = async (rowKey) => {
  try {
    // Include any identifier (EmpCode + Date) for backend to update a unique row
    await axios.put(`${API}/attendance/update`, editData);
setData((prev) =>
      prev.map((row) =>
        row.EmpCode === editData.EmpCode &&
        row.Date === editData.Date
          ? { ...row, ...editData }
          : row
      )
    );
    setEditRow(null);
    setEditData({});
   // reload table
  } catch (err) {
    alert("Save failed: " + err.response?.data?.message || err.message);
  }
};

  const resetRow = () => {
  setEditRow(null);
  setEditData({});
};

  const inputStyle = { padding: "8px 10px", borderRadius: "6px", border: "1px solid #ccc", fontSize: "13px" };
  const thStyle = { backgroundColor: "#198754", color: "white", padding: "6px", fontSize: "12px", textAlign: "center", position: "sticky", top: 0, zIndex: 2, border: "1px solid #ccc" };
  const tdStyle = { padding: "6px", fontSize: "12px", border: "1px solid #e0e0e0" };
  const footerStyle = { position: "sticky", bottom: 0, backgroundColor: "#d1e7dd", fontWeight: "bold", fontSize: "12px", padding: "6px", zIndex: 3 };

  const columns = [
    { label: "Employee Code", db: "EmpCode" },
    { label: "Name", db: "Name" },
    { label: "In Time", db: "IN" },
    { label: "Out Time", db: "OUT" },
    { label: "Working Hours", db: "WORKING" },
    { label: "Break Time", db: "Break" },
    { label: "Date", db: "Date" },
    { label: "Designation", db: "DESIG" },
    { label: "Department", db: "DEPARTMENT" },
    { label: "Location", db: "location" },
    { label: "Nationality", db: "COUNTRY" },
    { label: "Remarks", db: "REMARKS" },
  ];

  const totals = useMemo(() => {
    if (!data.length) return {};
    const t = {};
    columns.forEach((col) => {
      if (["WORKING"].includes(col.db)) {
        t[col.db] = data.reduce((acc, r) => acc + Number(r[col.db] || 0), 0).toFixed(2);
      }
    });
    return t;
  }, [data]);

  const handleChange = (field, value) => {
  setEditData((prev) => ({
    ...prev,
    [field]: value,
  }));
};

 return (
  <div style={{ paddingTop: "20px", paddingRight: "20px", paddingBottom: "0", paddingLeft: "10px" }}>

  <div style={{ display: "flex",
          alignItems: "center",
          gap: "10px",
          marginBottom: "10px", }}>
    <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} style={{ ...inputStyle, fontSize: "15px", padding: "6px", border: "1px solid #999", borderRadius: "6px"}} />
    <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} style={{ ...inputStyle, fontSize: "15px",  padding: "6px", border: "1px solid #999", borderRadius: "6px" }} />
    <button onClick={fetchData} style={{ padding: "10px 20px", backgroundColor: "#198754", color: "#fff", border: "none", borderRadius: "6px", cursor: "pointer" }}>
      {loading ? "Loading..." : "Proceed"}
    </button>
  </div>


    {/* Table: only after clicking Proceed */}
    {hasSearched && data.length > 0 && (
      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col.db} style={thStyle}>
                  {col.label}
                </th>
              ))}
              <th style={thStyle}>Action</th>
            </tr>
          </thead>

    {/* =================== TABLE BODY =================== */}
<tbody>
  {data.map((row, idx) => {
    // Create a unique key for each row (EmpCode + Date + idx)
    const rowKey = `${row.EmpCode}-${row.Date}-${idx}`;
    const isEditing = editRow === rowKey;

    return (
      <tr key={rowKey}>
        {columns.map((col) => (
          <td
            key={col.db}
            style={tdStyle}
            onDoubleClick={() => startEdit(row, rowKey)}
          >
            {isEditing && col.db !== "EmpCode" ? (
              <input
                style={{ width: "100%", padding: "4px" }}
                value={editData[col.db] || ""}
                onChange={(e) => handleChange(col.db, e.target.value)}
              />
            ) : (
              row[col.db] ?? "NULL"
            )}
          </td>
        ))}

        <td style={tdStyle}>
          {isEditing ? (
            <>
              <span
                onClick={() => saveRow(rowKey)}
                style={{
                  color: "#ff8800", // orange to stand out
                  textDecoration: "underline",
                  cursor: "pointer",
                  marginRight: "10px",
                  fontWeight: "500",
                }}
              >
                Save
              </span>
              <span
                onClick={() => resetRow()}
                style={{
                  color: "#dc3545", // red
                  textDecoration: "underline",
                  cursor: "pointer",
                  fontWeight: "500",
                }}
              >
                Reset
              </span>
            </>
          ) : (
            <span
              onClick={() => startEdit(row, rowKey)}
              style={{
                color: "#6f42c1", // purple to stand out
                textDecoration: "underline",
                cursor: "pointer",
                fontWeight: "500",
              }}
            >
              Edit
            </span>
          )}
        </td>
      </tr>
    );
  })}
</tbody>
          <tfoot>
            <tr>
              {columns.map((col) => (
                <td key={col.db} style={footerStyle}>
                  {totals[col.db] ?? ""}
                </td>
              ))}
              <td style={footerStyle}></td>
            </tr>
          </tfoot>
        </table>
      </div>
      
    )}

    {loading && <Loader />}
  </div>
);
}
export default AttendanceReport;
